import Entity from '@/structure/entity/Entity'

export default class Tag extends Entity {
  areaCode = null
  tagCategory = null
  color = null
  updatedAt = null
  deleted = null

  constructor (data = {}) {
    super()
    data && this.updateData(data)
  }
}
